module.exports = __webpack_public_path__ + "static/media/spinner.eaa47b66.gif";